<template>
  <div class="customers-task-table">
    <div class="ms-filter">
      <ms-form-filter
        :filters="filters"
        default-search="title"/>
    </div>
    <ms-grid
      :data="items"
      :columns="columns"
      :options="options"
      :pager="pager"
      @notFoundItem="newTasks">
      <el-checkbox
        slot="completed"
        slot-scope="{row}"
        v-model="row.completed"
        type="checkbox"
        @change="updateTask(row)"/>
      <span
        slot="title"
        slot-scope="{row}"
        :class="{completed:row.completed}">
        {{ row.title }}
      </span>
    </ms-grid>
    <tasks-preview
      v-if="showPrevTaskPanel"
      :current-task="currentTask"/>
    <tasks-create-view
      v-if="showTaskPanel"
      :is-edit="isEdit"
      :old="oldTask"/>
  </div>
</template>

<script>
import MsGrid from '@/modules/grid/ms-grid'
import MsFormFilter from '@/components/_shared/ms-form-filter'
import TasksPreview from '@/views/app/tasks/tasks-preview'
import CustomerGuards from '@/guards/customers.guards'
import moment from 'moment'
import TasksCreateView from '@/views/app/tasks/tasks-create-view'

export default {
  name: 'CustomersTaskTable',
  components: {
    MsGrid,
    MsFormFilter,
    TasksPreview,
    TasksCreateView
  },
  data () {
    return {
      filters: [
        {
          type: 'date',
          property: 'createdAt',
          props: {
            label: 'Fecha de creación'
          },
          queryFunction: function (val) {
            let _query
            if (!Array.isArray(val)) {
              _query = {
                'filters[whereBetween][createdAt]': val ? [moment(val).format('YYYY-MM-DD'), moment(val).add(1, 'day').format('YYYY-MM-DD')] : null
              }
            } else {
              _query = {
                'filters[whereBetween][createdAt]': [moment(val[0]).format('YYYY-MM-DD'), moment(val[1]).format('YYYY-MM-DD')]
              }
            }
            return _query
          }
        },
        {
          type: 'date',
          property: 'createdAt',
          props: {
            label: 'Fecha programada'
          },
          queryFunction: function (val) {
            let _query
            if (!Array.isArray(val)) {
              _query = {
                'filters[whereBetween][dueDate]': val ? [moment(val).format('YYYY-MM-DD'), moment(val).add(1, 'day').format('YYYY-MM-DD')] : null
              }
            } else {
              _query = {
                'filters[whereBetween][dueDate]': [moment(val[0]).format('YYYY-MM-DD'), moment(val[1]).format('YYYY-MM-DD')]
              }
            }
            return _query
          }
        },
        {
          type: 'boolean',
          property: 'completed',
          props: {
            label: 'Status',
            options: [
              {
                label: 'Completada',
                value: true
              },
              {
                label: 'Por Completar',
                value: false
              }
            ]
          }
        }
      ],
      columns: [
        {
          property: 'completed',
          label: 'Completada',
          align: 'center'
        },
        {
          property: 'title',
          label: 'Título',
          align: 'left'
        },
        {
          property: 'opportunity',
          label: 'Oportunidad',
          align: 'center'
        },
        {
          property: 'createdAt',
          label: 'Fecha de creación',
          align: 'center',
          type: 'date'
        },
        {
          property: 'dueDate',
          label: 'Fecha de programación',
          align: 'center',
          type: 'date'
        }
      ],
      options: {
        selectable: false,
        actions: [
          {
            label: 'Consultar',
            icon: 'icon-eye',
            onClick: (row) => {
              this.$store.dispatch('app/togglePrevTaskPanel')
              this.currentTask = row
            }
          },
          {
            label: 'Editar',
            icon: 'icon-edit',
            onClick: (row) => {
              this.onEdit(row)
            }
          }
        ]
      },
      oldTask: null,
      isEdit: false
    }
  },
  computed: {
    items () {
      return this.$store.getters['tasks/items']
    },
    pager () {
      return this.$store.getters['tasks/pagination']
    },
    showPrevTaskPanel () {
      return this.$store.getters['app/showPrevTaskPanel']
    },
    showTaskPanel () {
      return this.$store.getters['app/showTaskPanel']
    }
  },
  methods: {
    newTasks () {
      this.$store.dispatch('app/toggleTasksPanel')
    },
    updateTask (model) {
      this.$store.dispatch('tasks/save', model)
        .then(response => {
          this.$message.success('La tarea se ha actualizado con éxito')
        })
        .catch(e => {
          this.$message.error('La tarea no pudo se actualizada')
          model.completed = !model.completed
        })
    },
    onEdit (val) {
      this.oldTask = val
      this.isEdit = true
      this.$store.dispatch('app/toggleTasksPanel')
    }
  },
  beforeRouteUpdate: CustomerGuards.onGetList('tasks')
}
</script>

<style lang="scss" scoped>
.customers-task-table{
  .ms-filter{
    margin: -20px -20px 0 -20px;
  }
  .completed{
    text-decoration: line-through ;
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/customers/customers-task-table.vue